/**
 * ADRE Online Licensing System Web API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { DefinitionListModel } from './definitionListModel';
import { StringWithHyperlinkParametersModel } from './stringWithHyperlinkParametersModel';


/**
 * Model for displaying content in a list
 */
export class ContentPageListItemModel { 
    /**
     * If the parent ContentPageListModel is defined as a DefinitionList then the DefinitionListItem model will be present
     */
    DefinitionListItem?: DefinitionListModel;
    /**
     * If the parent ContentPageListModel is defined as any other list type then the GeneralListItem model will be present
     */
    GeneralListItem?: StringWithHyperlinkParametersModel;
}



// WEBPACK FOOTER //
// ./src/app/model/contentPageListItemModel.ts